import instockImage from "@/assets/images/in-stock.png";
import expiredImage from "@/assets/images/export.png";
import manufacturedImage from "@/assets/images/manufactured.png";
import productValImage from "@/assets/images/product-value.png";
import { KeyValueObj } from "@/common/types";
import { formatToNaira } from "@/common/utils/general";

export const tableHeaders = [
  "Name",
  "Unit",
  "Strength",
  "Storage",
  "Qty",
  "Min Level",
  "Supply",
  "Selling Price",
];
export const tableKeys = [
  "name",
  "unit",
  "strength",
  "storage",
  "quantity",
  "minLevel",
  "supply",
  "selling_price",
];
export const tableData = [
  {
    name: "Adderal 5mg tabs",
    itemId: "MEDEX11122",
    unit: "TAB",
    storage: "A1.21",
    quantity: 300,
    minLevel: 20,
    supply: "In 5 days",
  },
  {
    name: "Chloroquin 5mg tabs",
    itemId: "MEDEX13422",
    unit: "CAP",
    storage: "A1.21",
    quantity: 300,
    minLevel: 20,
    supply: "In 19 days",
  },
  {
    name: "Paracetamol",
    itemId: "MEDEX55522",
    unit: "TAB",
    storage: "BC.21",
    quantity: 300,
    minLevel: 100,
    supply: "In 2 days",
  },
  {
    name: "Lemenfathrine 200mg",
    itemId: "MEDEX11122",
    unit: "PATCH",
    storage: "A1.21",
    quantity: 300,
    minLevel: 30,
    supply: "In 11 days",
  },
];

// ********* Old **********
export const inventoryForm2 = [
  {
    inputType: "number",
    prompt: `Quantity`,
    name: "quantity_received",
    placeholder: "Type the quantity to be added",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "text",
    prompt: "Batch Number",
    name: "batch_number",
    placeholder: "Type the batch number",
    fullWidth: false,
    rules: {
      minLength: {
        errorMessage: "should be at least 2 characters",
        expectedValue: 2,
      },
    },
  },

  {
    inputType: "number",
    prompt: "Cost price per unit (NGN)",
    name: "cost_price_per_unit",
    placeholder: "Type the cost price per unit",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "number",
    prompt: "Selling price per unit (NGN)",
    name: "selling_price_per_unit",
    placeholder: "Type the selling price per unit",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "date",
    prompt: "Manufacture Date",
    name: "manufacture_date",
    placeholder: "Select manufacture date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: true,
        errorMessage: "Manufacture date cannot be in the future",
      },
    },
  },
  {
    inputType: "date",
    prompt: "Expiry Date",
    name: "expiry_date",
    placeholder: "Select expiry date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: false,
        errorMessage: "Product has expired",
      },
    },
  },
];

// ============ invertory filter params =========== //
export const InventoryFilterOptions = [
  {
    name: "manufacture_date",
    label: "Manufacturer Date",
    type: "date",
  },

  {
    name: "expiry_date",
    label: "Expiry Data",
    type: "date",
  },
  // {
  //   name: "status_term",
  //   label: "Delivery Status",
  //   type: "radio",
  //   options: [
  //     { label: "Accepted", value: "accepted" },
  //     { label: "Rejected", value: "rejected" },
  //     { label: "Completed", value: "completed" },
  //     { label: "Processed", value: "processed" },
  //     { label: "Canceled", value: "canceled" },
  //     { label: "Pending", value: "draft" },
  //     { label: "Failed", value: "failed" },
  //   ],
  // },
];

// ============== inventory form data =============== //
export const inventoryForm = [
  {
    inputType: "number",
    prompt: "Cost price per unit (NGN)",
    name: "cost_price_per_unit",
    placeholder: "Type the cost price per unit",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "number",
    prompt: "Selling price per unit (NGN)",
    name: "selling_price_per_unit",
    placeholder: "Type the selling price per unit",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "text",
    prompt: "Batch Number",
    name: "batch_number",
    placeholder: "Type the batch number",
    fullWidth: false,
    rules: {
      minLength: {
        errorMessage: "should be at least 2 characters",
        expectedValue: 2,
      },
    },
  },
  {
    inputType: "date",
    prompt: "Manufacture Date",
    name: "manufacture_date",
    placeholder: "Select manufacture date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: true,
        errorMessage: "Manufacture date cannot be in the future",
      },
    },
  },

  {
    inputType: "date",
    prompt: "Expiry Date",
    name: "expiry_date",
    placeholder: "Select expiry date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: false,
        errorMessage: "Expiry date cannot be in the past",
      },
    },
  },
  {
    inputType: "text",
    prompt: "Carton Serial No.",
    name: "carton_serial",
    placeholder: "Carton serial number",
    fullWidth: false,
  },
  {
    inputType: "text",
    prompt: "Pack Serial No.",
    name: "pack_serial",
    placeholder: "Carton serial number",
    fullWidth: false,
  },

  {
    inputType: "text",
    prompt: "Unit Serial No.",
    name: "unit_serial",
    placeholder: "Carton serial number",
    fullWidth: false,
  },
];

export interface ICardDetails {
  title: string;
  value: string;
  imageUrl: string;
  bg: string;
}

export function getCardDetails(data: any) {
  return [
    {
      title: "Total Products Value",
      value: formatToNaira(data?.total_products_value),
      imageUrl: productValImage,
      bg: "stat_1",
    },
    {
      title: "Total Products in Stock",
      value: data?.total_products_in_stock,
      imageUrl: instockImage,
      bg: "stat_2",
    },
    {
      title: "Manufactured Products",
      value: data?.total_products_manufactured,
      imageUrl: manufacturedImage,
      bg: "stat_3",
    },
    {
      title: "Total Expired Products",
      value: data?.total_expired_products,
      imageUrl: expiredImage,
      bg: "stat_4",
    },
  ];
}

export const getBarchartData = (barUserData: any) => ({
  labels: barUserData?.map((data: any) => data?.month),
  datasets: [
    {
      label: "Stock Value (in carton)",
      data: barUserData?.map((data: any) => data?.sales_value),
      backgroundColor: "#ECAF57",
      barThickness: 8,
    },
  ],
});

export const tableHeadersShort = [
  "Order Date",
  "Expected Delivery Date",
  "Payment Term",
  "Order Status",
  "Total Amount",
];
export const tableKeysShort = [
  "orderDate",
  "expectedDeliveryDate",
  "paymentTerm",
  "status",
  "totalAmount",
];
export const getRecentOrderTableData = (data: KeyValueObj[]) =>
  data?.map((datum: KeyValueObj) => ({
    status: { value: datum?.order_status, type: "string" },
    expectedDeliveryDate: {
      value: datum?.expected_delivery_date,
      type: "string",
    },
    orderDate: { value: datum?.created_at, type: "string" },
    paymentTerm: { value: datum?.payment_term, type: "string" },
    totalAmount: { value: formatToNaira(datum?.total_amount), type: "string" },
    id: datum?.id,
  }));
